module.exports = __webpack_public_path__ + "img/9corazon.33ab7891.png";